import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["host", "origin", "disablePageLayout", "requestHeaders"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import getDisplayName from "react-display-name";
import hoistNonReactStatics from "hoist-non-react-statics";
import App from "next/app";
import Head from "next/head";
import absoluteUrl from "next-absolute-url";
import { AnalyticsVendors, AppExperimentProvider } from "@catchoftheday/analytics";
import { getFontTags } from "@catchoftheday/cg-components";
import { CustomerContextProvider } from "@catchoftheday/customer";
import { embeddedConfig, getEnvConfig } from "@catchoftheday/env-config";
import { withApollo } from "@catchoftheday/graphql-utils";
import { Assets } from "@common-vendors/components/Assets";
import { DataDogRUM } from "@common-vendors/components/DataDog";
import { Forter } from "@common-vendors/components/Forter";
import { Normalizer } from "@common-vendors/components/Normalizer";
import { Polyfills } from "@common-vendors/components/Polyfills";
import { SEO } from "@common-vendors/components/SEO";
import { redirectBasedOnUA } from "./uaRedirect/uaRedirect";
import { jsx as ___EmotionJSX } from "@emotion/react";

var CommonVendors = function CommonVendors(_ref) {
  var host = _ref.host,
      seo = _ref.seo,
      fonts = _ref.fonts,
      children = _ref.children;

  var _getEnvConfig = getEnvConfig(),
      ENV_NAME = _getEnvConfig.ENV_NAME,
      DISABLE_LOCAL_ANALYTICS = _getEnvConfig.DISABLE_LOCAL_ANALYTICS,
      WAF_URL = _getEnvConfig.WAF_URL;

  var isLocalDevelopmentEnv = ENV_NAME === "development";
  var isProdEnv = ENV_NAME === "absinthe" || ENV_NAME === "website-prod";
  var disableLocalAnalytics = isLocalDevelopmentEnv && DISABLE_LOCAL_ANALYTICS;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Normalizer, null), ___EmotionJSX(Polyfills, null), ___EmotionJSX(Assets, null), ___EmotionJSX(Head, null, ___EmotionJSX("meta", {
    name: "cg:app:name",
    content: embeddedConfig.APP_NAME
  }), ___EmotionJSX("meta", {
    name: "cg:app:version",
    content: embeddedConfig.VERSION
  }), getFontTags({
    fonts: fonts
  }), isProdEnv ? ___EmotionJSX("script", {
    type: "application/javascript",
    src: WAF_URL,
    defer: true
  }) : null), ___EmotionJSX(SEO, seo), ___EmotionJSX(DataDogRUM, null), ___EmotionJSX(Forter, null), disableLocalAnalytics ? ___EmotionJSX(React.Fragment, null, children) : ___EmotionJSX(AnalyticsVendors, {
    host: host
  }, children));
};

/**
 * This is a HOC that should wrap all the microfrontend Next __app.tsx components and include common behaviour such as analytics
 */
export var nextAppHOC = function nextAppHOC(props) {
  return function (Comp) {
    var _ref2 = props || {},
        graphqlEndpoint = _ref2.graphqlEndpoint,
        vendors = _ref2.vendors,
        apolloCacheConfig = _ref2.apolloCacheConfig,
        defaultOptions = _ref2.defaultOptions,
        connectToDevTools = _ref2.connectToDevTools,
        seo = _ref2.seo,
        fonts = _ref2.fonts,
        retryOptions = _ref2.retryOptions,
        _ref2$isProxiedThroug = _ref2.isProxiedThroughCotdWeb,
        isProxiedThroughCotdWeb = _ref2$isProxiedThroug === void 0 ? false : _ref2$isProxiedThroug;

    if (!graphqlEndpoint) {
      throw new Error("GRAPHQL_ENDPOINT must be defined");
    }

    function WrappedComponent(_ref3) {
      var host = _ref3.host,
          origin = _ref3.origin,
          disablePageLayout = _ref3.disablePageLayout,
          requestHeaders = _ref3.requestHeaders,
          rest = _objectWithoutProperties(_ref3, _excluded);

      // `disablePageLayout` is set to `true` if the request originates from a Kubernetes readiness probe.
      // If the request originates from a readiness probe, we don't want to include any external vendor providers.
      if (disablePageLayout) return ___EmotionJSX(Comp, _extends({}, rest, {
        host: host,
        disablePageLayout: disablePageLayout
      }));
      return ___EmotionJSX(CustomerContextProvider, null, ___EmotionJSX(AppExperimentProvider, {
        forwardHeaders: requestHeaders,
        ssr: true
      }, ___EmotionJSX(CommonVendors, _extends({
        seo: _objectSpread(_objectSpread({}, seo), {}, {
          origin: origin
        }),
        host: host,
        fonts: fonts
      }, vendors), ___EmotionJSX(Comp, _extends({}, rest, {
        host: host
      })))));
    }

    function getInitialProps(_x) {
      return _getInitialProps.apply(this, arguments);
    }

    function _getInitialProps() {
      _getInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appContext) {
        var _appContext$ctx$req, _appContext$ctx$req2, _appContext$ctx$req3, _Comp$getInitialProps;

        var host, ctx, req, _absoluteUrl, origin, requestUrl, disableLayoutForRoutesStartingWith, disablePageLayout, _yield$Promise$all, _yield$Promise$all2, appProps, innerProps, appInitialProps;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (appContext.ctx.req && appContext.ctx.res && !isProxiedThroughCotdWeb) {
                  // Redirect to mobile web if the user is on a mobile device and the app isn't served via a mobile web host, and vice versa.
                  // Only do this if the app isn't proxied through cotdweb.
                  redirectBasedOnUA(appContext.ctx.req, appContext.ctx.res);
                }

                host = ((_appContext$ctx$req = appContext.ctx.req) === null || _appContext$ctx$req === void 0 ? void 0 : _appContext$ctx$req.headers["x-forwarded-host"]) || ((_appContext$ctx$req2 = appContext.ctx.req) === null || _appContext$ctx$req2 === void 0 ? void 0 : _appContext$ctx$req2.headers.host) || "";
                ctx = appContext.ctx;
                req = ctx.req;
                _absoluteUrl = absoluteUrl(req), origin = _absoluteUrl.origin; // Check if the request originates from a Kubernetes readiness probe

                requestUrl = ((_appContext$ctx$req3 = appContext.ctx.req) === null || _appContext$ctx$req3 === void 0 ? void 0 : _appContext$ctx$req3.url) || "";
                disableLayoutForRoutesStartingWith = ["/readyz", "/header"];
                disablePageLayout = disableLayoutForRoutesStartingWith.some(function (r) {
                  return requestUrl.startsWith(r);
                }); // calls page's `getInitialProps` and fills `appProps.pageProps`

                _context.next = 10;
                return Promise.all([App.getInitialProps(appContext), (_Comp$getInitialProps = Comp.getInitialProps) === null || _Comp$getInitialProps === void 0 ? void 0 : _Comp$getInitialProps.call(Comp, appContext)]);

              case 10:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                appProps = _yield$Promise$all2[0];
                innerProps = _yield$Promise$all2[1];
                appInitialProps = _objectSpread(_objectSpread(_objectSpread({}, appProps), innerProps), {}, {
                  host: host,
                  origin: origin,
                  disablePageLayout: disablePageLayout,
                  requestHeaders: req === null || req === void 0 ? void 0 : req.headers
                });
                return _context.abrupt("return", appInitialProps);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getInitialProps.apply(this, arguments);
    }

    hoistNonReactStatics(WrappedComponent, Comp);
    WrappedComponent.displayName = "NextAppHOC(".concat(getDisplayName(Comp), ")");
    WrappedComponent.getInitialProps = getInitialProps;
    return withApollo({
      uri: graphqlEndpoint,
      cacheConfig: apolloCacheConfig,
      defaultOptions: defaultOptions,
      connectToDevTools: connectToDevTools,
      retryOptions: retryOptions
    })(WrappedComponent); // Force cast, as `nextWithApollo` has excessively strict typing.
  };
};